import {
  buildUnifiedFeed,
  type EventRow,
  partitionTodayTasks,
  type TaskRow,
} from './schedule';

/**
 * How many items the Today tab is showing (YAR-399).
 *
 * The drawer badge is the aggregate of Today's section counters, and the two
 * must always reconcile — a badge reading 5 above a page showing 4 is worse
 * than no badge. That guarantee is structural here: this sums the output of
 * the very functions the section headers count, so the filters cannot drift
 * apart. Do not reimplement the partitioning inline.
 *
 * All THREE counted sections are included. Today renders Overdue, Happening
 * Today and Unscheduled; the spec comment on the ticket named only the first
 * two while also defining the badge as "everything the Today tab renders on
 * open", which is the reading followed here.
 *
 * Deliberately NOT child-filtered: the child chips are a per-view filter on
 * the Today page, while the badge describes the household's day from
 * anywhere in the app.
 */
export function countTodayItems(
  tasks: TaskRow[],
  events: EventRow[],
  today: string,
  timezone?: string | null,
): number {
  const { overdue, todayDated, noDate } = partitionTodayTasks(
    tasks,
    today,
    timezone,
  );
  return (
    overdue.length + buildUnifiedFeed(events, todayDated).length + noDate.length
  );
}
